import React, { useId } from 'react';
import './TeamVerifiedBadge.css';

/**
 * Selo de verificação exclusivo de membros do Vih's Studio.
 * Tooltip personalizado ao passar o mouse.
 */
export default function TeamVerifiedBadge({
  size = 'md',
  className = '',
  tooltipPlacement = 'top',
}) {
  const gradId = useId().replace(/:/g, '');

  return (
    <span
      className={`team-verified team-verified--${size} team-verified--tip-${tooltipPlacement}${className ? ` ${className}` : ''}`}
      tabIndex={0}
      aria-label="Verificado — membro do Vih's Studio"
    >
      <svg
        className="team-verified__mark"
        viewBox="0 0 20 20"
        aria-hidden="true"
        focusable="false"
      >
        <defs>
          <linearGradient id={gradId} x1="3" y1="2" x2="17" y2="18" gradientUnits="userSpaceOnUse">
            <stop offset="0%" stopColor="#ddd6fe" />
            <stop offset="45%" stopColor="#a78bfa" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>
        </defs>
        <circle cx="10" cy="10" r="9" fill={`url(#${gradId})`} />
        <path
          className="team-verified__check"
          d="M5.8 10.15l2.55 2.55 5.7-5.85"
          fill="none"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <span className="team-verified__tip" role="tooltip">
        <span className="team-verified__tip-brand">Vih&apos;s Studio</span>
        <span className="team-verified__tip-text">
          Membro verificado do Vih&apos;s Studio / Vih&apos;s
        </span>
      </span>
    </span>
  );
}
